export default __webpack_public_path__ + "static/media/correct.565c0870.mp3";